class MScalingLogo extends HTMLElement {
  constructor() {
    super();

    this.logo = this.querySelector(".m-scaling-logo__logo");
    this.logoWrapper = this.querySelector(".m-scaling-logo__logo-wrapper");
    this.content = this.querySelector(".m-scaling-logo__content");

    this.headerDesktop = document.querySelector(".m-header__desktop");
    this.headerMobile = document.querySelector(".m-header__mobile");
    this.headerWrapper = document.querySelector(".m-header__wrapper");
    this.header = document.querySelector(".m-header");

    this.headerStyle = this.header && this.header.dataset.sticky;
    this.siteHeader = document.querySelector("m-header");

    this.OFFSET_VH = 30;
    this.ticking = false;

    this.init();

    window.addEventListener(
      "resize",
      debounce(() => this.init(), 100)
    );

    window.addEventListener("scroll", () => {
      if (this.ticking) return;

      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.scrollAnimation();
        this.ticking = false;
      });
    });
  }

  init() {
    if (!this.logoWrapper || !this.logo) {
      console.warn("Scaling Logo: wrapper o logo no encontrados");
      return;
    }

    // Recuperamos siempre el tamaño final definido en CSS
    this.logo.style.removeProperty("width");
    this.logo.style.removeProperty("transform");

    // Por seguridad, eliminamos cualquier estado heredado
    this.logo.classList.remove("m:hidden");
    this.logo.classList.remove("is-scaling-finished");

    this.baseWidth =
      parseFloat(window.getComputedStyle(this.logo).width) || 140;

    this.startOffset =
      (this.OFFSET_VH / 100) * window.innerHeight;

    /*
     * Equivalente a la fórmula que tenías antes:
     *
     * initialScale = innerWidth / logoWidth - adjustment
     *
     * pero convertido directamente en píxeles.
     */
    const adjustment = window.innerWidth > 768 ? 3 : 1;

    this.initialWidth = Math.max(
      this.baseWidth,
      window.innerWidth - this.baseWidth * adjustment
    );

    this.logo.style.width = `${this.initialWidth}px`;

    this.logo.style.transform =
      `translate3d(0, ${this.startOffset}px, 0)`;

    this.siteHeader?.classList.add("logo-scaling");

    if (this.headerStyle !== "none") {
      this.headerDesktop?.classList.add("m:fade-out");
      this.headerMobile?.classList.add("m:fade-out");
    } else {
      this.classList.add("m-scaling-logo--sticky-none");
    }

    this.scrollAnimation();
  }

  scrollAnimation() {
    if (!this.logo || !this.header) return;

    const scroll = window.pageYOffset;

    const winH =
      window.innerHeight -
      this.header.offsetHeight -
      1;

    const p = Math.min(
      Math.max(scroll / Math.max(winH, 1), 0),
      1
    );

    // Ancho real del logo
    const width =
      this.initialWidth -
      (this.initialWidth - this.baseWidth) * p;

    // Movimiento vertical
    const ty =
      this.startOffset * (1 - p);

    /*
     * Safari:
     * modificamos width real.
     * NO usamos transform: scale().
     */
    this.logo.style.width = `${width}px`;

    /*
     * Solo transformamos en Y.
     * El centrado horizontal lo hace flex.
     */
    this.logo.style.transform =
      `translate3d(0, ${ty}px, 0)`;

    // Fade del contenido
    if (scroll > winH / 2) {
      this.content?.classList.add("m:fade-out");
    } else {
      this.content?.classList.remove("m:fade-out");
    }

    const atFinal = p >= 0.999;

    /*
     * Estado del header durante el scaling
     */
    if (this.siteHeader) {
      if (atFinal) {
        this.siteHeader.classList.remove("logo-scaling");
      } else {
        this.siteHeader.classList.add("logo-scaling");
      }
    }

    /*
     * Al llegar al final:
     * - NO usamos m:hidden porque sería display:none inmediato
     * - añadimos una clase que hace fade mediante opacity
     */
    if (atFinal) {
      this.headerWrapper?.classList.remove("m-unset-shadow");

      this.logo.classList.add("is-scaling-finished");

      if (this.headerStyle !== "none") {
        this.headerDesktop?.classList.remove("m:fade-out");
        this.headerMobile?.classList.remove("m:fade-out");
      }
    } else {
      this.headerWrapper?.classList.add("m-unset-shadow");

      this.logo.classList.remove("is-scaling-finished");

      if (this.headerStyle !== "none") {
        this.headerDesktop?.classList.add("m:fade-out");
        this.headerMobile?.classList.add("m:fade-out");
      }
    }
  }
}

if (!customElements.get("m-scaling-logo")) {
  customElements.define("m-scaling-logo", MScalingLogo);
}

function debounce(fn, wait) {
  let t;

  return function (...args) {
    clearTimeout(t);

    t = setTimeout(() => {
      fn.apply(this, args);
    }, wait);
  };
}